import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Speakers = () => {
  return (
    <React.Fragment>
      <SEO title="Speakers | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Plenary Speakers &amp; Invited Speakers
        "
        content="For Participants"
        contentTwo="Plenary Speakers &amp; Invited Speakers
        "
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>


        <div className="entry-content">
          {/* <h2>The information is to be announced. </h2> */}


          {/* <h4>Plenary Speakers Candidates</h4> */}



        </div>
        <div className="entry-content">

          <span>&nbsp;</span>

          <p align="justify">
            <h3>Title:</h3>
            <h4>Role of Autoencoders in Accelerating Swarm Optimizers to Solve High-dimensional Expensive Problems</h4>
            <br />
            <h5>Abstract:</h5>
            High-dimensional computationally expensive problems (HEPs) in which a single fitness evaluation consumes hours or even days have attracted increasing attention from both academia and industry. Exponentially expanding search space and complex landscape brought by high-dimensional decision variables make HEPs extremely challenging to be solved by traditional algorithms with limited physical/computational resources. Therefore, an Autoencoder-embedded Evolutionary Optimization (AEO) framework is invented to deal with them. To be specific, high-dimensional search space can be compressed to informative low-dimensional space by using an autoencoder as a dimension reduction tool. The search operation conducted in this low-dimensional space facilitates the population in convergence towards the optima. To balance the exploration and exploitation ability during optimization, two sub-populations are adopted to coevolve in a distributed fashion, wherein one is assisted by an autoencoder and the other undergoes a regular evolutionary process. Dynamic information exchange is conducted between them after each cycle to promote sub-population diversity. Moreover, surrogate models can be incorporated into AEO (SAEO) to further boost its performance by reducing unnecessary fitness evaluation. Compared with the state-of-the-art algorithms for HEPs, AEO shows extraordinarily high efficiency for these challenging problems while SAEO can greatly improve the performance of AEO in most cases, thus opening new directions for various swarm optimization and evolutionary algorithms under both AEO and SAEO to tackle HEPs and greatly advancing the field of high-dimensional computationally expensive optimization.
            <br></br>
            <br></br>
            <h4>Speaker: </h4>
            <br />




            <p text-align="center">
              <img src="images/avatar/zhou.jpg" alt="Xu" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. MengChu Zhou</div>
                <br />
                Fellow of IEEE, IFAC, AAAS, CAA and NAI
                <br />
                Distinguished Professor and Director, Laboratory for Discrete Event Systems, New Jersey Institute of Technology
              </strong>
            </p>
            <h5>Biography:</h5>
            MengChu Zhou received his B.S. degree in Control Engineering from Nanjing University of Science and Technology, Nanjing, China in 1983, M.S. degree in Automatic Control from Beijing Institute of Technology, Beijing, China in 1986, and Ph. D. degree in Computer and Systems Engineering from Rensselaer Polytechnic Institute, Troy, NY in 1990.  He joined New Jersey Institute of Technology (NJIT), Newark, NJ in 1990, and has been Distinguished Professor in Electrical and Computer Engineering since 2013. He is presently a professor with Zhejiang Gongshang University. His research interests are in Petri nets, intelligent automation, Cloud/edge Computing, Internet of Things, big data, web services, and intelligent transportation.  He has over 1100 publications including 14 books, 750+ journal papers (600+ in IEEE transactions), 31 patents and 32 book-chapters. He is the founding Editor of IEEE Press Book Series on Systems Science and Engineering, Editor-in-Chief of IEEE/CAA Journal of Automatica Sinica, and Associate Editor of IEEE Internet of Things Journal, IEEE Transactions on Intelligent Transportation Systems, and IEEE Transactions on Systems, Man, and Cybernetics: Systems. He is a recipient of Humboldt Research Award for US Senior Scientists from Alexander von Humboldt Foundation, Franklin V. Taylor Memorial Award and the Norbert Wiener Award from IEEE Systems, Man and Cybernetics Society, Excellence in Research Prize and Medal from NJIT, and Edison Patent Award from the Research & Development Council of New Jersey. He is highly cited scholar with over 58,600 Google Scholar citations and h-index 122. He has been among most highly cited scholars since 2012 and ranked top one in the field of engineering worldwide in 2012 by Web of Science. He has over 58,600 GoogleScholar citations with h-index 122. He was ranked #89 in the world and #58 in the United States among the 2022 Top 1000 Scientists in Computer Science in the World, Research.com. He is a life member of Chinese Association for Science and Technology-USA and served as its President in 1999. He is a Fellow of IEEE, International Federation of Automatic Control (IFAC), American Association for the Advancement of Science (AAAS), Chinese Association of Automation (CAA), and National Academy of Inventors (NAI).
          </p>
          <hr />



          <span>&nbsp;</span>
          <span>&nbsp;</span>


          <p align="justify">
            <h3>Title:</h3>
            <h4>Modelling and Solution Set Constraints in MOEA/D</h4>
            <br />
            <h5>Abstract:</h5>
            Most multi-objective evolutionary algorithms are to generate a finite set of solutions to approximate the Pareto optimal solution set (PS) in the decision space and the Pareto front (PF) in the objective space. In other words, these algorithms provide a zero-order approximation to the PS and PF. In this talk, I will first introduce basic ideas behind MOEA/D algorithms and explain how to use MOEA/D to learn a math model to approximate the PS and PF.  In some engineering design areas, it is desirable or required that different optimal solutions should share some common patterns.  I will explain our recently proposed concept of “solution set constraints” and show some of our preliminary work on using modelling in MOEA/D to handle these constraints. Our work can be regarded as a new attempt to do “innovization”, and it also provides a new way for defining optimality in multiobjective optimization.   It can provide more useful information for supporting interactive multiobjective optimization.
            <br></br>
            <br></br>
            <h4>Speaker: </h4>
            <br />




            <p text-align="center">
              <img src="images/avatar/qingfu.jpg" alt="Xu" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. Qingfu Zhang</div>
                {/* <br />
                Fellow of IEEE, IFAC, AAAS, CAA and NAI */}
                <br />
                Chair Professor, Department of Computer Science, City University of Hong Kong
              </strong>
            </p>
            <h5>Biography:</h5>
            Qingfu Zhang is a Chair Professor of Computational Intelligence with the Department of Computer Science, City University of Hong Kong. His is an IEEE fellow. His main research interests include evolutionary computation, optimization, metaheuristic, machine learning and their applications.  He leads the AI and Meaheutistics Group and is supervising or co-supervising 17 PhD students and 7 research fellows/assistants in CityU.  His MOEA/D algorithms have been widely researched in the EMO field and used in industry.
 
          </p>
          <hr />



          <span>&nbsp;</span>
          <span>&nbsp;</span>

          <p align="justify">
            <h4>Title: Swarm Intelligence Algorithms & Their Impact on Error Control Coding Scheme</h4>
            <br />
            <h5>Abstract:</h5>
            Since the early nineteenth century, an exhaustive research has been advanced in the field of the optimization algorithms and its application in modern engineering problems. Various linear programing approaches like Pontyagrin’s method, Bellman’s theory, etc. have been used exhaustively in this century for the evaluation of the optimal solutions in different engineering aspects. Here initial solutions have been updated numerically or analytically by using gradient information. However, the performances of these existing techniques are not satisfactory when they have been applied on the rough nonlinear surfaces. Hence, design of robust and commanding nature-inspired SWARM INTELLEGENCE algorithm is one of the emerging fields of investigation in engineering optimization zone to solve the above mentioned problem. In these algorithms and their improved version where the candidate solutions have been split into small entities for accomplishment of the partitioned search space. Afterwards, several standard benchmark functions have been used to evaluate the performance of those algorithms. The name of the few algorithms are: Cuckoo search (CS) Algorithm, Harmony search (HS) Algorithm and Particle Swarm Optimization (PSO) Algorithm, Symbiotic Organism Search (SOS) Algorithm etc.
            Furthermore, all these algorithms have been applied to design various kinds of Turbo Codes (TCs) having lower Bit Error rates (down to 10-8) for the implementation of the real time and more demanding applications such as TV broadcasting or videoconferencing.

          </p>
          <br />
          <h4>Speaker: </h4>
          <br />
          <p text-align="center">
            <img src="images/avatar/banerjee.jpg" alt="okyay" width={159} />
          </p>
          <strong>
            <div id="name">Dr. Subhabrata Banerjee</div>
            <br />
            Professor,Institute of Engineering & Management, Kolkata, India.
          </strong>
          <br />
          <br />

          <p align="justify">
            <h5>Biography:</h5>
            Dr. Subhabrata Banerjee is a Professor in the department of Electronics and Communication Engineering, Institute of Engineering & Management, Kolkata, India. He was awarded National Scholarship by WBED, West Bengal Government. He received his M.Tech. and PhD degrees in Electronics and Telecommunication Engineering from renowned Jadavpur University, Kolkata, India. He initially worked as Programmer Analysist in Cognizant Technology Solution and then was working as Assistant Professor in the Department of Electronics and Communication Engineering at Future Institute of Engineering and Management, Kolkata, India and as Associate Professor in the same institution thereafter. He is now working as Professor in Institute of Engineering and Management, Kolkata, India since 2021. He was authored numerous articles published in prestigious journals including Wireless Personal Communication (Springer), Personal and Ubiquitous Computing (Springer), International Journal of Communication Systems (Wiley) and Institution of Engineering and Technology (IET, UK). He has published more than 30 papers in International Conferences and International Journals of repute. He also published book chapter under IET, UK publication. He has also published a book named Genetic Algorithms and Machine Learning for Python Programmers. His current research interests include Communication and Coding Theory, Machine Learning, Robotics, IOT, Control System, and Evolutionary Algorithms, Soft Computation.
          </p>
          <hr />
          <span>&nbsp;</span>
          <span>&nbsp;</span>


          <br />


        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Speakers;
